if (!customElements.get('info-popover')) {
  customElements.define(
    'info-popover',
    class InfoPopover extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.variant-info-popover__button');
        this.panel = this.querySelector('.variant-info-popover__panel');

        if (!this.button || !this.panel) return;

        this.button.addEventListener('click', this.toggle.bind(this));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        document.addEventListener('click', this.onDocumentClick.bind(this));
      }

      toggle(event) {
        event.preventDefault();
        this.isOpen() ? this.close() : this.open();
      }

      open() {
        this.button.setAttribute('aria-expanded', 'true');
        this.panel.removeAttribute('hidden');
      }

      close() {
        this.button.setAttribute('aria-expanded', 'false');
        this.panel.setAttribute('hidden', '');
      }

      isOpen() {
        return this.button.getAttribute('aria-expanded') === 'true';
      }

      onKeyUp(event) {
        if (event.key === 'Escape' && this.isOpen()) {
          this.close();
          this.button.focus();
        }
      }

      onDocumentClick(event) {
        if (this.isOpen() && !this.contains(event.target)) {
          this.close();
        }
      }
    }
  );
}
